import React from 'react';
import { injectIntl, IntlProvider } from 'react-intl';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';

import CmsIconSearch from './CmsIconSearch';

class CmsIconSelector extends React.Component {
  handleChange = icon => {
    const { setParam } = this.props;

    setParam('icon', icon);

    // dispatch a click event so that the overlay closes
    document.dispatchEvent(
      new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
      })
    );
  };

  render() {
    const { label, getParamValue, intl } = this.props;

    const icon = getParamValue('icon', '');

    return (
      <div class="form-group form-group-default" style={{ position: 'relative' }}>
        <label>{label}</label>
        <div style={{ position: 'relative', width: '100%' }}>
          <OverlayTrigger
            trigger="click"
            rootClose
            placement="left"
            overlay={
              <Popover class="popover-modal">
                <IntlProvider locale={intl.locale} messages={intl.messages}>
                  <CmsIconSearch onSelect={this.handleChange} />
                </IntlProvider>
              </Popover>
            }
          >
            <Button>
              {icon ? <i class={'fa ' + icon} /> : 'Default icon'} <i class="fa fa-sort-desc m-l-10" />
            </Button>
          </OverlayTrigger>
        </div>
      </div>
    );
  }
}

export default injectIntl(CmsIconSelector);
